/* eslint-disable no-unused-vars,react/no-array-index-key */
import { Box } from '@mui/material'

import Spinner from '../../../../Spinner'
import ListItem from './components/ListItem'
import ListNewItem from './components/ListNewItem'
import { useListData } from './hooks/useListData'

import useStyles from './style'
import HtmlTooltip from '../../../../HtmlTooltip'

const List = () => {
  const { isFetching, isItemsUpdating, keywordList, dynamicRowName, dynamicRowKey } = useListData()
  const classes = useStyles()

  return (
    <Box className={classes.box}>
      <Box className={classes.header}>
        <Box>Keyword</Box>
        <Box>
          <HtmlTooltip title="Hovering over a value shows the tracking period">
            Search <br />
            volume
          </HtmlTooltip>
        </Box>
        <Box>Impressions</Box>
        <Box>
          Impression <br />
          share (%)
        </Box>
        <Box>Organic rank</Box>
        <Box>
          <HtmlTooltip title="Hovering over a value shows the tracking period">
            Advertising <br />
            rank*
          </HtmlTooltip>
        </Box>
        <Box>Clicks</Box>
        <Box>Conversions</Box>
        <Box>ACoS (%)</Box>
        <Box>
          Keyword <br />
          boosting
        </Box>
        <Box>
          Fixed <br /> bid
        </Box>
      </Box>
      <Box className={classes.list}>
        {(isFetching || isItemsUpdating) && <Spinner />}
        {!isFetching && !isItemsUpdating && keywordList.length === 0 && (
          <Box className={classes.empty}>No keywords have been selected for rank targeting</Box>
        )}
        {!isFetching &&
          !isItemsUpdating &&
          keywordList.length > 0 &&
          keywordList.map((item, index) => {
            if (!item.searchPhrase) {
              return <ListNewItem {...item} key={item.id} />
            }
            return <ListItem {...item} key={item.id} />
          })}
      </Box>
      <Box className={classes.legend}>* Bol only provides advertising rank data for a subset of keywords</Box>
    </Box>
  )
}

export default List
